import { scheduleService } from '@libs/data-access/queries'
import { isValidTime } from '@spa/components/FormFields/helpers'
import moment from 'moment'

import { computeShiftDates } from '../../utils'
import type FormData from '../Models/FormData'

type Props = {
  contractId?: number
  date: string
  shiftTimeRange: FormData['shift_time_range']
  breaks: FormData['breaks']
}
export const useFloatingBreaksWarning = ({
  contractId,
  date,
  shiftTimeRange,
  breaks
}: Props) => {
  const { startDate, endDate } = computeShiftDates(shiftTimeRange, moment(date))
  const [start_at, end_at] = shiftTimeRange
  const isValidTimes = isValidTime(start_at) && isValidTime(end_at)

  const { data } = scheduleService.shift.break.useFetchFloatingBreaksWarning(
    {
      queryParams: {
        user_contract_id: contractId,
        shift_starts_at: isValidTimes ? startDate.format() : null,
        shift_ends_at: isValidTimes ? endDate.format() : null
      }
    },
    {
      enabled: Boolean(contractId)
    }
  )

  const someBreaksWhithoutTime = breaks.some(
    // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
    ({ value }) => !isValidTime(value?.timeRange?.[0])
  )
  if (someBreaksWhithoutTime && data?.warning) {
    return true
  }

  return false
}
